import React, { useState, useEffect } from "react";
import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import "./common.css";
import { AiTwotoneDelete, AiTwotoneEdit, AiTwotoneEye } from "react-icons/ai";
import API_URL from "../common/Apiurl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SuccessMessage from "../common/Message";
import SearchBar from "material-ui-search-bar";
import ExportExcel from "../excelsheet/Excelexport";
import { useParams } from 'react-router-dom';

function Joblisting() {
  // new table
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [alljobs, setAlljobs] = useState([]);
  const [alldata, setAlldata] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [deleteconfirm, setDeleteconfirm] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [searched, setSearched] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handleOpen = (e, id) => {
    setOpen(true);
    setDeleteconfirm(id);
  };
  const handleClose = () => setOpen(false);
  const getData = localStorage.getItem("user-info");
  const accessbility = JSON.parse(getData).data.accessbility;
  const { jobType, userId } = useParams();
  
  useEffect(() => {
    const getComments = async () => {
      try {
        if(!jobType && !userId){
          const postData = {
            limit: 10,
            offset: 0,
          };
          const res = await fetch(`${apiUrl}/admin/alljobs`, {
            // const res = await fetch(`${apiUrl}/admin/joblisting`,{
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            //   body:JSON.stringify(postData)
          });
          const data = await res.json();
          if (data.status !== 200) {
            throw new Error("Data not found");
          }
          // const total = data.totaljob;
          // setpageCount(Math.ceil(total / limit));
          setAlljobs(data.alljob);
          setItems(data.data);
          setAlldata(data.alljob);
        }
        else if(jobType === "posted") {
          // console.log(jobType ,userId)
          const postData = {
            user_id: userId
          };
          const res = await fetch(`${apiUrl}/admin/get_created_jobs`, {
            // const res = await fetch(`${apiUrl}/admin/joblisting`,{
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
              body:JSON.stringify(postData)
          });
          const data = await res.json();
          if (data.status !== 200) {
            throw new Error("Data not found");
          }
          // const total = data.totaljob;
          // setpageCount(Math.ceil(total / limit));
          setAlljobs(data.alljob);
          setItems(data.data);
          setAlldata(data.data);
        }
        else if(jobType === "completed") {
          const postData = {
            user_id: userId,
            status: "completed"
          };
          const res = await fetch(`${apiUrl}/admin/get_created_jobs`, {
            // const res = await fetch(`${apiUrl}/admin/joblisting`,{
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
              body:JSON.stringify(postData)
          });
          const data = await res.json();
          if (data.status !== 200) {
            throw new Error("Data not found");
          }
          // const total = data.totaljob;
          // setpageCount(Math.ceil(total / limit));
          setAlljobs(data.alljob);
          setItems(data.data);
          setAlldata(data.data);
        }
        else if(jobType === "hired") {
          const postData = {
            user_id: userId
          };
          const res = await fetch(`${apiUrl}/admin/hiredJobs`, {
            // const res = await fetch(`${apiUrl}/admin/joblisting`,{
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
              body:JSON.stringify(postData)
          });
          const data = await res.json();
          if (data.status !== 200) {
            throw new Error("Data not found");
          }
          // const total = data.totaljob;
          // setpageCount(Math.ceil(total / limit));
          setAlljobs(data.alljob);
          setItems(data.data);
          setAlldata(data.data);
        }
        else if(jobType === "applied") {
          const postData = {
            user_id: userId
          };
          const res = await fetch(`${apiUrl}/admin/jobsApplied`, {
            // const res = await fetch(`${apiUrl}/admin/joblisting`,{
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
              body:JSON.stringify(postData)
          });
          const data = await res.json();
          if (data.status !== 200) {
            throw new Error("Data not found");
          }
          // const total = data.totaljob;
          // setpageCount(Math.ceil(total / limit));
          setAlljobs(data.alljob);
          setItems(data.data);
          setAlldata(data.data);
        }
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  // get industry

  const deletejob = async (e, id) => {
    e.preventDefault();
    setOpen(false);
    try {
      const posttodeleteData = {
        job_id: id,
      };
      const resultdelete = await fetch(`${apiUrl}/admin/admindeletejob`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(posttodeleteData),
      });
      const deleteddata = await resultdelete.json();
      const newSuccessMessage = deleteddata.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
      if (deleteddata.status !== 200) {
        throw new Error("Data not found");
      }
    } catch (error) {
      console.log("Error: ", error);
    }
    // console.log(id);
  };
  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    window.location.reload();
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 495,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // new added
  var rows = alljobs.sort((a, b) => (a.title < b.flag ? -1 : 1));
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const requestSearch = (searchedVal) => {
    var rows = alldata;
    const filteredRows = rows.filter((row) => {
      const restult1 = row.creatoremail.toLowerCase().includes(searchedVal.toLowerCase());
      // console.log(restult1);
      // return
        if (!restult1) {
          const restult2 = row.title.toLowerCase().includes(searchedVal.toLowerCase());
          if (!restult2) {
            const restult3 = row.industries.toLowerCase().includes(searchedVal.toLowerCase());
            if (!restult3) {
              const restult4 = row.categories.toLowerCase().includes(searchedVal.toLowerCase());
              if (!restult4) {
                return row.subcategories.toLowerCase().includes(searchedVal.toLowerCase());
              } else {
                return restult4;
              }
            } else {
              return restult3;
            }

          } else {
            return restult2;
          }
        } else {
          return restult1;
        }
    });
    // if (filteredRows.length === 0) {
    //   const filteredRowstwo = rows.filter((row) => {
    //     console.log("row");
    //     console.log(row);
    //     // return row.provideremail.toLowerCase().includes(searchedVal.toLowerCase());
    //     return row.description
    //       .toLowerCase()
    //       .includes(searchedVal.toLowerCase());
    //   });
    //   setItems(filteredRowstwo);
    // } else {
    //   setItems(filteredRows);
    // }
    if (filteredRows.length === 0) {
      setAlljobs([]);
    } else {
      setAlljobs(filteredRows);
    }
  };
  rows = alljobs.sort((a, b) => (a.title < b.flag ? -1 : 1));

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
    const allRows = alldata;
    setItems(allRows);
  };
  rows = alljobs.sort((a, b) => (a.title < b.flag ? -1 : 1));
  // new added

  const newArray = [];
  // const itemsValue = items
  const itemsValue = alljobs;
  itemsValue.map((dataItem, index) => {
    const newItem = {
      Number: index + 1,
      JobTitle: dataItem.title,
      JobCreator: dataItem.creatorname,
      CreatorEmail: dataItem.creatoremail,
      JobRequested: dataItem.providername,
      RequesterEmail: dataItem.provideremail,
      JobApplicant: dataItem.appliedname,
      ApplicantEmail: dataItem.appliedemail,
      Industry: dataItem.industries,
      Category: dataItem.categories,
      Subcategory: dataItem.subcategories,
      Address: dataItem.address,
      Status: dataItem.status,
      StartDate: dataItem.start_date,
      EndDate: dataItem.end_date,
    };
    newArray.push(newItem);
  });
  const ExcelExportData = newArray;

  return (
    <div className="width90">
      <div className="row">
        <div className="col-sm-6">
          <h2 className="pageTitle">Job Listing</h2>
        </div>
      </div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className="mt-4"
      />
      {/* excelsheet */}
      <div className="form-group mt-3">
        <div className="row">
          <div className="col-sm-9"></div>
          <div className="col-sm-3 text-end">
            <label
              className="control-label col-sm-10 label"
              htmlFor="exportData"
            >
              Export Data
            </label>
            <ExportExcel excelData={ExcelExportData} fileName={"Jobs"} />
          </div>
        </div>
      </div>
      {/* excelsheet */}
      {/* root */}
      <Root sx={{ maxWidth: "100%", width: 500 }}>
        <table aria-label="custom pagination table" className="cntr">
          <thead>
            <tr>
              <th>Job Title</th>
              <th>Creator Name</th>
              <th>Creator Email</th>
              <th>Description</th>
              <th>Industry</th>
              <th>Category</th>
              <th>Sub Category</th>

              <th>Start Date</th>
              <th>End Date</th>
              <th>Address</th>
              {/* <th>No. of position</th>
                      <th>Specialism</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row) => (
              // <tr key={row.category_name}>
              <tr>
                <td>{row.title}</td>
                <td>{row.creatorname}</td>
                <td>{row.creatoremail}</td>
                <td>{row.description}</td>
                <td>{row.industries}</td>
                <td>{row.categories}</td>
                <td>{row.subcategories}</td>
                <td>{row.start_date}</td>
                <td>{row.end_date}</td>
                <td>{row.address}</td>
                {/* <td>{row.no_position}</td>
                            <td>{row.specialism}</td> */}
                {/* {row.status === '1'? Active(row.id):Blocked(row.id)} */}
                <td style={{}} align="right">
                  {accessbility?.jobs.read === 1 ||
                  accessbility?.jobs.read === true ? (
                    <Link
                      to={`/admin/alljobs/jobdetails/${row.id}`}
                      className="view"
                    >
                      <AiTwotoneEye />
                    </Link>
                  ) : null}
                  {accessbility?.jobs.write === 1 ||
                  accessbility?.jobs.write === true ? (
                    <Link
                      to={`/admin/alljobs/jobupdate/${row.id}`}
                      className="edit"
                    >
                      <AiTwotoneEdit />
                    </Link>
                  ) : null}
                  {accessbility?.jobs.write === 1 ||
                  accessbility?.jobs.write === true ? (
                    <button
                      type="button"
                      className="delete"
                      onClick={(e) => handleOpen(e, row.id)}
                    >
                      <AiTwotoneDelete />
                    </button>
                  ) : null}
                </td>
              </tr>
            ))}
            {emptyRows > 0 && (
              <tr style={{ height: 41 * emptyRows }}>
                <td colSpan={6} aria-hidden />
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <CustomTablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={12}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                slotProps={{
                  select: {
                    "aria-label": "rows per page",
                  },
                  actions: {
                    showFirstButton: true,
                    showLastButton: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </tr>
          </tfoot>
        </table>
      </Root>
      {/* root */}
      {/*  */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to delete this Job?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={(e) => deletejob(e, deleteconfirm)}
            >
              OK
            </Button>
            <Button
              variant="contained"
              onClick={handleClose}
              className="cancelbtn"
            >
              Cancel
            </Button>
          </Typography>
        </Box>
      </Modal>
      {/*  */}
      {successMessages.map((message, index) => (
        <SuccessMessage
          key={index}
          message={message}
          onFadeOut={handleSuccessMessageFadeOut}
        />
      ))}
    </div>
  );
}

const grey = {
  200: "#d0d7de",
  800: "#32383f",
  900: "#24292f",
};

const Root = styled("div")(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    text-align: left;
    padding: 8px;
  }

  th {
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  }
  `
);

const CustomTablePagination = styled(TablePagination)`
  & .${classes.toolbar} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.spacer} {
    display: none;
  }

  & .${classes.actions} {
    display: flex;
    gap: 0.25rem;
  }
`;
export default Joblisting;
